export function isClosedRequest(status) {
  return status === "SETTLED" || status === "DD_DELIVERED" || status === "REJECTED" || status === "CANCELLED" || status === "EXPIRED";
}

export function statusTone(status) {
  if (status === "REJECTED" || status === "CANCELLED" || status === "EXPIRED") return "is-bad";
  if (status === "SETTLED" || status === "DD_DELIVERED") return "is-done";
  if (status === "AWAITING_CHOICE") return "is-live";
  return "is-wait";
}

export function receivesPaperDraft(row) {
  if (!row) return true;
  if (row.dd && row.dd.direction === "crypto_to_fiat") return true;
  if (row.dd && row.dd.direction === "fiat_to_crypto") return false;
  if (row.getKind === "fiat") return true;
  if (row.payKind === "fiat") return false;
  return false;
}

function offlineReceive(row) {
  const draft = row && row.dd;
  const details = row && row.clientDetails;
  if (draft && draft.destination === "wallet") return true;
  if (details && details.destination === "wallet") return true;
  return false;
}

export function stageLabel(status, row) {
  if (status === "AWAITING_CHOICE") return "Active";
  if (status === "PENDING_SETTLEMENT" || status === "HELD") return "Sent for settlement";
  if (status === "PENDING_DD") return "Due diligence";
  if (status === "DD_CREATING") {
    if (row && offlineReceive(row)) return "Offline delivery";
    return "DD is being created";
  }
  if (status === "DD_COLLECT") return offlineReceive(row) ? "Ready to collect" : "Collect your DD";
  if (status === "DD_DELIVERED") return "Delivered";
  if (status === "SETTLED") return "Completed";
  if (status === "REJECTED") return "Rejected";
  if (status === "CANCELLED") return "Cancelled";
  if (status === "EXPIRED") return "Expired";
  return status || "";
}

export function requestDay(value) {
  const date = new Date(value || 0);
  if (!value || Number.isNaN(date.getTime())) return "";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

export function requestWhen(value) {
  const day = requestDay(value);
  if (!day) return "—";
  const [year, month, date] = day.split("-");
  return `${date}/${month}/${year}`;
}

export function receiveLine(row) {
  const draft = (row && row.dd) || {};
  const details = (row && row.clientDetails) || {};
  if (draft.payeeName) return `Demand draft · ${draft.payeeName}`;
  if (draft.destination === "wallet") return draft.reference ? `External wallet · ${draft.reference}` : "External wallet";
  if (draft.destination === "spot") return "Spot wallet";
  if (details.destination === "wallet") return details.reference ? `External wallet · ${details.reference}` : "External wallet";
  if (details.destination === "bank") return details.reference ? `Bank · ${details.reference}` : "Bank";
  if (details.destination === "spot") return "Spot wallet";
  return "—";
}
